import { produce } from "immer";
import { 
    GET_EMPLOYEE_REPORT_DETAILED_TABLE_FAILURE,
    GET_EMPLOYEE_REPORT_DETAILED_TABLE_REQUEST,
    GET_EMPLOYEE_REPORT_DETAILED_TABLE_SUCCESS,
    GET_EMPLOYEE_REPORT_DROPDOWN_FILTER_FAILURE, 
    GET_EMPLOYEE_REPORT_DROPDOWN_FILTER_REQUEST, 
    GET_EMPLOYEE_REPORT_DROPDOWN_FILTER_SUCCESS 
} from "./salesEmployeeTabSliceConstants";

const initialNewReportsState = {
    employeeReportDropdownFilterLoading: false,
    employeeReportDropdownFilterSuccess: [],
    employeeReportDropdownFailure : false,

    employeeReportDetailedTableLoading: false,
    employeeReportDetailedTableSuccess: [],
    employeeReportDetailedTableFailure: false,
}

export default function SalesEmployeeTabSliceReducer(state = initialNewReportsState, action) {
    return produce(state, (draft) => {
        switch (action.type) {
            case GET_EMPLOYEE_REPORT_DROPDOWN_FILTER_REQUEST:
                draft.employeeReportDropdownFilterLoading = true;
                draft.employeeReportDropdownFilterSuccess = [];
                draft.employeeReportDropdownFailure = false;
                break;
            case GET_EMPLOYEE_REPORT_DROPDOWN_FILTER_SUCCESS:
                draft.employeeReportDropdownFilterLoading = false;
                draft.employeeReportDropdownFilterSuccess = action.payload;
                draft.employeeReportDropdownFailure = false;
                break;
            case GET_EMPLOYEE_REPORT_DROPDOWN_FILTER_FAILURE:
                draft.employeeReportDropdownFilterLoading = false;
                draft.employeeReportDropdownFilterSuccess = [];
                draft.employeeReportDropdownFailure = true;
                break;

            case GET_EMPLOYEE_REPORT_DETAILED_TABLE_REQUEST:
                draft.employeeReportDetailedTableLoading = true;
                draft.employeeReportDetailedTableSuccess = [];
                draft.employeeReportDetailedTableFailure = false;
                break;
            case GET_EMPLOYEE_REPORT_DETAILED_TABLE_SUCCESS:
                draft.employeeReportDetailedTableLoading = false;
                draft.employeeReportDetailedTableSuccess = action.payload;
                draft.employeeReportDetailedTableFailure = false;
                break;
            case GET_EMPLOYEE_REPORT_DETAILED_TABLE_FAILURE:
                draft.employeeReportDetailedTableLoading = false;
                draft.employeeReportDetailedTableSuccess = [];
                draft.employeeReportDetailedTableFailure = true;
                break;

            default:
                break;
        }
    })
}